import { __assign, __rest } from "tslib";
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable array-callback-return */
/* eslint-disable no-debugger */
var mapResolutionsToWixVideoQualities = function (resolutions) {
    return resolutions.map(function (resolution) {
        return {
            formats: [Object.keys(resolution.urls)[0]],
            height: resolution.height,
            quality: resolution.videoMode || resolution.height + 'p',
            width: resolution.width,
        };
    });
};
var createPhotoUrl = function (serverMediaUrl) {
    var mediaUrlStartIndex = serverMediaUrl.lastIndexOf('/');
    return serverMediaUrl.substring(mediaUrlStartIndex + 1);
};
var getLastUrlPath = function (url) {
    var splittedUrl = url.split('/');
    if (splittedUrl && splittedUrl.length > 0) {
        return splittedUrl.pop();
    }
    return '';
};
var extractMediaUrl = function (serverMediaUrl, serverUrlFormat) {
    var serverMediaUrlSplit = serverMediaUrl.split(serverUrlFormat);
    if (serverMediaUrlSplit && serverMediaUrlSplit.length === 2) {
        var serverMediaUrlSlashSplit = serverMediaUrlSplit.pop().split('/');
        if (serverMediaUrlSlashSplit.length > 0) {
            return serverMediaUrlSlashSplit[0];
        }
    }
    return '';
};
var wixMediaUrlFormats = [
    'video.wixstatic.com/video/',
    'static.wixstatic.com/media/video/', // new format
];
var getWixMediaUrlVideo = function (serverMediaUrl) {
    var serverUrlFormat = wixMediaUrlFormats.find(function (format) {
        return serverMediaUrl.includes(format);
    });
    return extractMediaUrl(serverMediaUrl, serverUrlFormat);
};
var mapProGalleryVideoPosters = function (serverPosters, isCustomPoster) {
    return serverPosters
        .filter(function (poster) {
        if (!isCustomPoster && (!('default' in poster) || !poster.default)) {
            return true;
        }
        if (isCustomPoster && ('default' in poster || !!poster.default)) {
            return true;
        }
        return false;
    })
        .map(function (poster) {
        return {
            height: poster.height,
            width: poster.width,
            url: getLastUrlPath(poster.url),
        };
    });
};
export var generateProGalleryLink = function (serverLink) {
    var serverLinkFieldOptions = [
        { serverLinkField: 'phone', type: 'PhoneLink' },
        { serverLinkField: 'email', type: 'EmailLink' },
        { serverLinkField: 'document', type: 'DocumentLink' },
        { serverLinkField: 'page', type: 'PageLink' },
        { serverLinkField: 'external', type: 'ExternalLink' },
        { serverLinkField: 'anchor', type: 'AnchorLink' },
        { serverLinkField: 'dynamicPage', type: 'DynamicPageLink' },
        { serverLinkField: 'tpaPage', type: 'TpaPageLink' },
    ];
    var proGalleryserverLink = serverLinkFieldOptions.find(function (_a) {
        var serverLinkField = _a.serverLinkField;
        return serverLink.wixLinkData && serverLink.wixLinkData["".concat(serverLinkField)];
    });
    if (!serverLink.wixLinkData) {
        return __assign(__assign({}, serverLink), { type: 'web' });
    }
    return __assign({ target: (proGalleryserverLink &&
            (serverLink === null || serverLink === void 0 ? void 0 : serverLink.wixLinkData["".concat(proGalleryserverLink.serverLinkField)].target)) ||
            serverLink.target, type: 'wix', data: __assign(__assign({}, ((proGalleryserverLink &&
            (serverLink === null || serverLink === void 0 ? void 0 : serverLink.wixLinkData["".concat(proGalleryserverLink.serverLinkField)])) || __assign({}, serverLink))), { type: (proGalleryserverLink === null || proGalleryserverLink === void 0 ? void 0 : proGalleryserverLink.type) || serverLink.type }) }, ('text' in serverLink && { text: serverLink.text }));
};
var buildProGalleryVideo = function (proGalleryItem, serverItem) {
    var _a, _b;
    var videoData = serverItem.videoMetadata;
    var isExternalVideo = 'source' in videoData && videoData.source !== 'Undefined';
    proGalleryItem = __assign(__assign(__assign({}, proGalleryItem), (isExternalVideo &&
        'posters' in videoData &&
        videoData.posters.length > 0 && {
        mediaUrl: getLastUrlPath(videoData.posters[0].url),
    })), (!isExternalVideo &&
        'mediaUrl' in serverItem && {
        mediaUrl: getWixMediaUrlVideo(serverItem.mediaUrl),
    }));
    proGalleryItem.metaData = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, proGalleryItem.metaData), { type: 'video' }), ('posters' in videoData && {
        customPoster: mapProGalleryVideoPosters(videoData.posters, true).length > 0
            ? mapProGalleryVideoPosters(videoData.posters, true)[0]
            : '',
    })), ('source' in videoData && { isExternal: isExternalVideo })), ('height' in videoData && { height: videoData.height })), ('width' in videoData && { width: videoData.width })), ('name' in serverItem && { name: serverItem.name })), ('posters' in videoData && {
        posters: mapProGalleryVideoPosters(videoData.posters, false),
    })), ('sourceName' in videoData && {
        isDemo: videoData.sourceName === 'private',
    })), (!isExternalVideo &&
        'resolutions' in videoData && {
        qualities: mapResolutionsToWixVideoQualities(videoData.resolutions),
    })), (isExternalVideo && { qualities: [] })), ('duration' in videoData && { duration: Number(videoData.duration) })), (isExternalVideo && { source: videoData.source.toLowerCase() })), (isExternalVideo && { videoUrl: serverItem.mediaUrl })), (isExternalVideo && { videoId: videoData.externalId })), ('posters' in videoData &&
        videoData.posters[0] &&
        'focalPoint' in videoData.posters[0] && {
        focalPoint: [
            videoData.posters[0].focalPoint.x,
            videoData.posters[0].focalPoint.y,
        ],
    }));
    proGalleryItem.metaData.height = ((_a = proGalleryItem.metaData) === null || _a === void 0 ? void 0 : _a.height) || 1080;
    proGalleryItem.metaData.width = ((_b = proGalleryItem.metaData) === null || _b === void 0 ? void 0 : _b.width) || 1920;
    proGalleryItem.mediaUrl = proGalleryItem.mediaUrl || 'undefined_poster';
    return proGalleryItem;
};
var photoGalleryQuality = function (photoData) {
    var shouldAddPhotoQuality = 'quality' in photoData || 'unsharpMasking' in photoData;
    return __assign({}, (shouldAddPhotoQuality && {
        sharpParams: {
            L: __assign(__assign({}, ('quality' in photoData && {
                overrideQuality: true,
                quality: photoData.quality,
            })), ('unsharpMasking' in photoData && {
                overrideUsm: true,
                usm: __assign(__assign(__assign({}, ('amount' in photoData.unsharpMasking && {
                    usm_a: photoData.unsharpMasking.amount,
                })), ('radius' in photoData.unsharpMasking && {
                    usm_r: photoData.unsharpMasking.radius,
                })), ('threshold' in photoData.unsharpMasking && {
                    usm_t: photoData.unsharpMasking.threshold,
                })),
            })),
        },
    }));
};
var buildProGalleryPhoto = function (proGalleryItem, serverItem) {
    var haveMediaUrl = 'mediaUrl' in serverItem && createPhotoUrl(serverItem.mediaUrl);
    proGalleryItem = __assign(__assign(__assign(__assign({}, proGalleryItem), (haveMediaUrl && { mediaUrl: createPhotoUrl(serverItem.mediaUrl) })), ('token' in serverItem && { token: serverItem.token })), ('imageToken' in serverItem && { imageToken: serverItem.imageToken }));
    var photoData = serverItem.photoMetadata;
    proGalleryItem.metaData = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, proGalleryItem.metaData), { sourceName: 'private' }), ('tags' in serverItem && { tags: serverItem.tags })), ('sourceName' in photoData && {
        isDemo: photoData.sourceName === 'private',
    })), ('height' in photoData && { height: photoData.height })), ('width' in photoData && { width: photoData.width })), ('focalPoint' in photoData &&
        photoData.focalPoint && {
        focalPoint: [photoData.focalPoint.x, photoData.focalPoint.y],
    })), ('name' in serverItem && { fileName: serverItem.name })), (haveMediaUrl && { name: createPhotoUrl(serverItem.mediaUrl) })), photoGalleryQuality(photoData));
    return proGalleryItem;
};
var buildProGalleryText = function (proGalleryItem, serverItem) {
    var textData = serverItem.textMetadata;
    var textDataHaveStyle = 'style' in textData;
    proGalleryItem = __assign(__assign({}, proGalleryItem), { mediaUrl: '' });
    proGalleryItem.metaData = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, proGalleryItem.metaData), { type: 'text' }), ('editorHtml' in textData && { editorHtml: textData.editorHtml })), ('html' in textData && { html: textData.html })), ('name' in serverItem && { name: serverItem.name })), ('fontPickerStyleParamName' in textData && {
        fontPickerStyleParamName: textData.fontPickerStyleParamName,
    })), (textDataHaveStyle &&
        'height' in textData.style && { height: textData.style.height })), (textDataHaveStyle &&
        'width' in textData.style && { width: textData.style.width })), (textDataHaveStyle && { textStyle: textData.style })), ('editorFontId' in textData && {
        fontPickerStyleParamName: textData.editorFontId,
    }));
    return proGalleryItem;
};
export var serverItemsToProGallery = function (serverItems) {
    try {
        var proGalleryItems = serverItems.map(function (serverItem) {
            var proGalleryItem = __assign(__assign(__assign(__assign(__assign({}, ('id' in serverItem && { itemId: serverItem.id })), ('secure' in serverItem && { isSecure: serverItem.secure })), ('createdDate' in serverItem && { createdDate: serverItem.createdDate })), ('orderIndex' in serverItem && {
                orderIndex: serverItem.orderIndex,
            })), { metaData: __assign(__assign(__assign(__assign(__assign({}, ('description' in serverItem && {
                    description: serverItem.description,
                })), ('title' in serverItem && { title: serverItem.title })), { link: {
                        type: 'none',
                        target: '_blank',
                    } }), ('link' in serverItem && {
                    link: generateProGalleryLink(serverItem.link),
                })), ('alt' in serverItem && {
                    alt: serverItem.alt,
                })) });
            if (serverItem.dataType === 'Video') {
                return buildProGalleryVideo(proGalleryItem, serverItem);
            }
            else if (serverItem.dataType === 'Photo') {
                return buildProGalleryPhoto(proGalleryItem, serverItem);
            }
            else if (serverItem.dataType === 'Text') {
                return buildProGalleryText(proGalleryItem, serverItem);
            }
            return {};
        });
        return proGalleryItems;
    }
    catch (e) {
        console.error('Wrong format for gallery items', serverItems, e);
        return [];
    }
};
// ------------------------------------------Pro Gallery to Server--------------------------------------------//
var serverLinkToUrl = function () {
    return {
        external: function (linkData) {
            return linkData.url;
        },
        phone: function (linkData) {
            return "";
        },
        email: function (linkData) {
            return "";
        },
        document: function (linkData) {
            return "https://docs.wixstatic.com/ugd/".concat(linkData.docId);
        },
        page: function (linkData) {
            return '';
        },
        anchor: function (linkData) {
            return '';
        },
        dynamicPage: function (linkData) {
            return '';
        },
        tpaPage: function (linkData) {
            return '';
        },
    };
};
var generateServerLink = function (proGalleryLink) {
    var _a;
    var proGalleryLinkFieldOptions = [
        { type: 'phone', proGalleryLinkField: 'PhoneLink', isInternal: false },
        { type: 'email', proGalleryLinkField: 'EmailLink', isInternal: false },
        {
            type: 'document',
            proGalleryLinkField: 'DocumentLink',
            isInternal: false,
        },
        { type: 'page', proGalleryLinkField: 'PageLink', isInternal: true },
        {
            type: 'external',
            proGalleryLinkField: 'ExternalLink',
            isInternal: false,
        },
        { type: 'anchor', proGalleryLinkField: 'AnchorLink', isInternal: true },
        {
            type: 'dynamicPage',
            proGalleryLinkField: 'DynamicPageLink',
            isInternal: true,
        },
        {
            type: 'tpaPage',
            proGalleryLinkField: 'TpaPageLink',
            isInternal: true,
        },
    ];
    var serverPGLink = proGalleryLinkFieldOptions.find(function (_a) {
        var proGalleryLinkField = _a.proGalleryLinkField;
        return proGalleryLink.data && proGalleryLink.data.type === proGalleryLinkField;
    });
    var _b = proGalleryLink.data || {}, type = _b.type, serverLinkData = __rest(_b, ["type"]);
    return serverPGLink
        ? {
            link: __assign(__assign(__assign({ target: proGalleryLink.target }, (serverLinkData &&
                serverPGLink && {
                wixLinkData: (_a = {},
                    _a[serverPGLink.type] = __assign({}, serverLinkData),
                    _a),
            })), ('text' in proGalleryLink && { text: proGalleryLink.text })), { type: serverPGLink && serverPGLink.isInternal ? 'Internal' : 'External', url: serverLinkToUrl()[serverPGLink.type](serverLinkData) }),
        }
        : {};
};
var buildServerPhoto = function (_a) {
    var proGalleryItem = _a.proGalleryItem, serverItem = _a.serverItem;
    var haveMediaUrl = 'mediaUrl' in proGalleryItem && createServerUrl(proGalleryItem.mediaUrl);
    serverItem = __assign(__assign(__assign(__assign({}, serverItem), (haveMediaUrl && { mediaUrl: createServerUrl(proGalleryItem.mediaUrl) })), ('token' in proGalleryItem && { token: proGalleryItem.token })), ('imageToken' in proGalleryItem && {
        imageToken: proGalleryItem.imageToken,
    }));
    var metaData = proGalleryItem.metaData;
    serverItem = __assign(__assign(__assign(__assign(__assign(__assign({}, serverItem), { dataType: 'Photo', photoMetadata: __assign(__assign(__assign(__assign(__assign(__assign({}, serverItem.photoMetadata), ('height' in metaData && { height: metaData.height })), ('width' in metaData && { width: metaData.width })), ('isDemo' in metaData && {
            sourceName: metaData.isDemo ? 'private' : 'public',
        })), ('focalPoint' in metaData &&
            metaData.focalPoint && {
            focalPoint: { x: metaData.focalPoint[0], y: metaData.focalPoint[1] },
        })), serverQuality(metaData)) }), ('name' in metaData && { name: metaData.fileName })), ('tags' in metaData ? { tags: metaData.tags } : { tags: [] })), (haveMediaUrl && { mediaUrl: createServerUrl(proGalleryItem.mediaUrl) })), (metaData.tags.join('').includes('_fileOrigin_uploaded')
        ? { mediaOwner: 'Undefined' }
        : { mediaOwner: 'Wix' }));
    return serverItem;
};
var buildServerText = function (_a) {
    var proGalleryItem = _a.proGalleryItem, serverItem = _a.serverItem;
    var metaData = proGalleryItem.metaData;
    serverItem = __assign(__assign(__assign(__assign(__assign({}, serverItem), { dataType: 'Text', textMetadata: __assign(__assign(__assign(__assign(__assign({}, serverItem.textMetadata), ('editorHtml' in metaData && { editorHtml: metaData.editorHtml })), ('html' in metaData && { html: metaData.html })), ('fontPickerStyleParamName' in metaData && {
            editorFontId: metaData.fontPickerStyleParamName,
        })), { style: __assign(__assign(__assign({}, ('height' in metaData && { height: metaData.height })), ('width' in metaData && { width: metaData.width })), ('textStyle' in metaData && __assign({}, metaData.textStyle))) }) }), ('name' in metaData && { name: metaData.name })), ('tags' in metaData ? { tags: metaData.tags } : { tags: [] })), { mediaOwner: 'Undefined' });
    return serverItem;
};
var buildServerVideo = function (_a) {
    var _b;
    var proGalleryItem = _a.proGalleryItem, serverItem = _a.serverItem;
    var metaData = proGalleryItem.metaData;
    var isExternalVideo = metaData.isExternal;
    serverItem = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, serverItem), { dataType: 'Video', videoMetadata: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, serverItem.videoMetadata), ('height' in metaData && { height: metaData.height })), ('width' in metaData && { width: metaData.width })), (isExternalVideo && {
            source: capitalizeFirstLetter(metaData.source),
        })), (!isExternalVideo && { source: 'Undefined' })), ('duration' in metaData && { duration: String(metaData.duration) })), (('posters' in metaData || 'customPoster' in metaData) && {
            posters: createServerPosters(metaData),
        })), ('isDemo' in metaData && {
            sourceName: metaData.isDemo ? 'private' : 'public',
        })), (!isExternalVideo &&
            'qualities' in metaData &&
            metaData.qualities.length > 0
            ? {
                resolutions: mapQualitiesToServerResolutions(metaData.qualities, proGalleryItem.mediaUrl),
            }
            : { resolutions: [] })), (isExternalVideo && {
            resolutions: [
                {
                    urls: (_b = {},
                        _b[capitalizeFirstLetter(metaData.source)] = metaData.videoUrl,
                        _b),
                },
            ],
        })), (isExternalVideo && { externalId: metaData.videoId })) }), (isExternalVideo && { mediaUrl: metaData.videoUrl })), (!isExternalVideo &&
        'mediaUrl' in proGalleryItem && {
        mediaUrl: Object.values(mapQualitiesToServerResolutions(metaData.qualities, proGalleryItem.mediaUrl).pop().urls)[0],
    })), ('name' in metaData && { name: metaData.name })), ('tags' in metaData ? { tags: metaData.tags } : { tags: [] })), (isExternalVideo || !metaData.source
        ? { mediaOwner: 'Undefined' }
        : { mediaOwner: 'Wix' }));
    return serverItem;
};
var serverQuality = function (metaData) {
    var shouldAddPhotoQuality = 'sharpParams' in metaData &&
        'L' in metaData.sharpParams &&
        ('unsharpMasking' in metaData.sharpParams.L ||
            'quality' in metaData.sharpParams.L);
    if (shouldAddPhotoQuality) {
        var L = metaData.sharpParams.L;
        return __assign({}, __assign(__assign({}, ('quality' in L && { quality: L.quality })), ('usm' in L && {
            unsharpMasking: __assign(__assign(__assign({}, ('usm_a' in L.usm && { amount: L.usm.usm_a })), ('usm_r' in L.usm && { radius: L.usm.usm_r })), ('usm_t' in L.usm && { threshold: L.usm.usm_t })),
        })));
    }
    else {
        return {};
    }
};
var createServerUrl = function (proGalleryUrl) {
    return proGalleryUrl.includes('https://') || proGalleryUrl.includes('http://')
        ? proGalleryUrl
        : "https://static.wixstatic.com/media/".concat(proGalleryUrl);
};
var capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
var createServerPosters = function (metaData) {
    var posters = [];
    var focalPointObject = metaData && metaData.focalPoint
        ? { focalPoint: { x: metaData.focalPoint[0], y: metaData.focalPoint[1] } }
        : {};
    metaData &&
        metaData.posters.map(function (poster) {
            posters.push(__assign(__assign(__assign(__assign({}, ('url' in poster && { url: createServerUrl(poster.url) })), ('height' in poster && { height: poster.height })), ('width' in poster && { width: poster.width })), focalPointObject));
        });
    if (metaData && metaData.customPoster && metaData.customPoster !== '') {
        var customPoster = metaData.customPoster;
        posters.push(__assign(__assign(__assign(__assign(__assign({}, ('url' in customPoster && { url: createServerUrl(customPoster.url) })), ('height' in customPoster && { height: customPoster.height })), ('width' in customPoster && { width: customPoster.width })), focalPointObject), { default: true }));
    }
    return posters;
};
var createResolutionsUrls = function (quality, mediaUrl) {
    var res = {};
    // eslint-disable-next-line array-callback-return
    quality.formats.map(function (format) {
        res[format] = "https://video.wixstatic.com/video/".concat(mediaUrl, "/").concat(quality.quality, "/").concat(format, "/file.").concat(format);
    });
    return res;
};
var mapQualitiesToServerResolutions = function (qualities, mediaUrl) {
    return qualities.map(function (quality) {
        return {
            height: quality.height,
            width: quality.width,
            videoMode: quality.quality,
            urls: __assign({}, createResolutionsUrls(quality, mediaUrl)),
        };
    });
};
export var proGalleryItemsToServer = function (proGalleryItems) {
    try {
        var serverItems = proGalleryItems.map(function (proGalleryItem) {
            var metaData = proGalleryItem.metaData;
            var link = ((metaData.link && generateServerLink(metaData.link)) || {}).link;
            var serverItem = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, ('itemId' in proGalleryItem && { id: proGalleryItem.itemId })), ('isSecure' in proGalleryItem && {
                secure: proGalleryItem.isSecure,
            })), ('orderIndex' in proGalleryItem && {
                orderIndex: proGalleryItem.orderIndex,
            })), (link && { link: link })), ('description' in metaData && { description: metaData.description })), ('title' in metaData && { title: metaData.title })), ('alt' in metaData && { alt: metaData.alt }));
            if (metaData.type === 'video') {
                return buildServerVideo({ serverItem: serverItem, proGalleryItem: proGalleryItem });
            }
            else if (metaData.type === 'text') {
                return buildServerText({ serverItem: serverItem, proGalleryItem: proGalleryItem });
            }
            else {
                return buildServerPhoto({ serverItem: serverItem, proGalleryItem: proGalleryItem });
            }
        });
        return serverItems;
    }
    catch (e) {
        console.error('Wrong format for pro gallery items', proGalleryItems, e);
        return [];
    }
};
